import { useMessageStore } from "./message";

// 状态选择器
export const useMessageList = () =>
  useMessageStore((state) => [...state.historyMsgList, ...state.msgList]);

// 获取正在pending的消息
export const usePendingMessages = () =>
  useMessageStore((state) =>
    state.msgList.filter((msg) => msg.status === "pending"),
  );

// 获取发送中的消息
export const useSendingMessages = () =>
  useMessageStore((state) =>
    state.msgList.filter((msg) => msg.status === "sending"),
  );

// 获取失败消息
export const useFailedMessages = () =>
  useMessageStore((state) =>
    state.msgList.filter((msg) => msg.status === "failed"),
  );

// 获取链接状态
export const useConnectionStatus = () =>
  useMessageStore((state) => state.isConnected);

// 插入消息
export const useAddOutgoingMessage = () =>
  useMessageStore((state) => state.addOutgoingMessage);

// 消息重试
export const useRetrySendMessage = () =>
  useMessageStore((state) => state.retrySendMessage);

// 获取初始历史消息
export const useInitializeHistory = () =>
  useMessageStore((state) => state.initializeHistory);

// 用户是否已发送第一条消息
export const useHasUserSentFirstMessage = () =>
  useMessageStore((state) => !!state.hasUserSentFirstMessage);
